import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ListEmisorTercerosComponent} from './cmp-list-emisorTerceros/list-emisorTerceros.component';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {ScrollEventModule} from "ngx-scroll-event";
import {NgStringPipesModule} from "../../../../../pipes/string";
import {MaterialModule} from "../../../../material.module";
import {UsuarioModule} from "../../seguridad/usuario/usuario.module";
import {PrettyJsonModule} from 'angular2-prettyjson';
import {MomentModule} from "angular2-moment";
import {LoadingModule} from "../../../../autenticacion/loadingScreen/loading.module";
import {MatButtonModule, MatExpansionModule, MatIconModule, MatInputModule, MatPaginatorIntl, MatTableModule} from '@angular/material';
import {CdkTableModule} from '@angular/cdk/table';
import {CurrencyMaskModule} from "ng2-currency-mask";
import {Ng2SmartTableModule} from 'ng2-smart-table';
import {FormEmisorTercerosComponent} from "./cmp-form-emisorTerceros/form-emisorTerceros.component";
import {ListDocumentsModule} from "./cmp-list-documents/listDocuments.module";
import {ListDetalleLoteComponent} from "./cmp-list-detalle-lote/list-detalle-lote.component";
import {BsDatepickerModule} from "ngx-bootstrap";
import { CustomMatPaginatorIntl } from 'app/autenticacion/servicios/paginator.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        NgStringPipesModule,
        ScrollEventModule,
        UsuarioModule,
        MaterialModule,
        MomentModule,
        PrettyJsonModule,
        LoadingModule,
        MatTableModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        CdkTableModule,
        CurrencyMaskModule,
        MatExpansionModule,
        Ng2SmartTableModule,
        ListDocumentsModule,
        BsDatepickerModule
    ],
    declarations: [
        ListEmisorTercerosComponent, FormEmisorTercerosComponent, ListDetalleLoteComponent],
    exports: [],
    providers: [{
        provide: MatPaginatorIntl, 
        useClass: CustomMatPaginatorIntl
      }]
})
export class EmisorTercerosModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/emisorTerceros/emisorTerceros.module.ts